import { useEffect, useState, type RefObject } from 'react'

/** Becomes true the first time the element is at least `threshold` visible, and stays true. */
export const useInView = (ref: RefObject<Element | null>, threshold: number) => {
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const element = ref.current
    if (!element || typeof IntersectionObserver === 'undefined') return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return
        setInView(true)
        observer.disconnect()
      },
      { threshold },
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [ref, threshold])

  return inView
}
